/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/uploadLogsLists.config.json";
// import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_UPLOAD_LOGS } from "../graphql";
import { VApplication } from "../../../application";
import { AppNavigatorService } from "../../appNavigatorService";

import { useEmailId } from "../../../pages/ProvisionalPage/provider";

import moment from "moment";

const getWhoamiSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetUploadLogsMethods extends IPluginMethodMap {
  getUploadLogsProps(args: any): Promise<any>;
}

export interface IGetUploadLogsProps {
  offset?: number;
  size?: number;
  where?: any;
}

export class UploadLogsService implements IAgentPlugin {
  
  readonly methods: IGetUploadLogsMethods;

  constructor() {
    this.methods = {
      getUploadLogsProps: this.getProps.bind(this),
    };
  }

  async getProps(args: IGetUploadLogsProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.query({
          query: GET_UPLOAD_LOGS,
          variables: {
            page: Math.floor((args?.offset ?? 0) / (args?.size ?? 10)) + 1,
            limit: args?.size ?? 10,
          },
          fetchPolicy: "network-only",
        });

        const trackerData = res?.data?.getTrackers;

        if (trackerData) {
          const formatted = this.formatTable(trackerData?.content);

          return {
            ultTableHeader: await this.getRowData(),
            ultUsers: formatted,
            isEmpty: trackerData?.content?.length <= 0,
            activePage: trackerData?.page,
            pageSize: trackerData?.limit,
            totalCount: trackerData?.count,
            totalPages: Math.ceil(trackerData?.count / trackerData?.limit),
          };
        }
      }
    } catch (err) {
      console.error("Upload Logs Error:", err);
      return {
        isEmpty: true,
      };
    }
  }

  private formatTable(data: any[]) {
  if (!Array.isArray(data)) return [];

  return data.map((tracker: any) => ({
    id: tracker?.tracker_id,
    name: tracker?.name,
    total: tracker?.total,
    success: tracker?.success,
    fail: tracker?.fail,
    status: tracker?.status,
    logs: tracker?.logs,
    createdAt: tracker?.createdAt
      ? moment(tracker?.createdAt).format("LLL")
      : "-"
  }));
}


  private async getRowData() {
     return [...config?.ultTableHeaderUser];
  }
}
